// [code, name, country for the flag]
const RAW = [
  ["hinglish", "Hinglish", "IN"], ["en", "English", "US"], ["hi", "Hindi", "IN"], ["bn", "Bengali", "IN"],
  ["ta", "Tamil", "IN"], ["te", "Telugu", "IN"], ["mr", "Marathi", "IN"], ["gu", "Gujarati", "IN"],
  ["kn", "Kannada", "IN"], ["ml", "Malayalam", "IN"], ["pa", "Punjabi", "IN"], ["ur", "Urdu", "PK"],
  ["ne", "Nepali", "NP"], ["as", "Assamese", "IN"], ["sa", "Sanskrit", "IN"], ["sd", "Sindhi", "PK"], ["si", "Sinhala", "LK"],
  ["af", "Afrikaans", "ZA"], ["sq", "Albanian", "AL"], ["am", "Amharic", "ET"], ["ar", "Arabic", "SA"],
  ["hy", "Armenian", "AM"], ["az", "Azerbaijani", "AZ"], ["ba", "Bashkir", "RU"], ["eu", "Basque", "ES"],
  ["be", "Belarusian", "BY"], ["bs", "Bosnian", "BA"], ["br", "Breton", "FR"], ["bg", "Bulgarian", "BG"],
  ["my", "Burmese", "MM"], ["yue", "Cantonese", "HK"], ["ca", "Catalan", "ES"], ["zh", "Chinese", "CN"],
  ["hr", "Croatian", "HR"], ["cs", "Czech", "CZ"], ["da", "Danish", "DK"], ["nl", "Dutch", "NL"],
  ["et", "Estonian", "EE"], ["fo", "Faroese", "FO"], ["fi", "Finnish", "FI"], ["fr", "French", "FR"],
  ["gl", "Galician", "ES"], ["ka", "Georgian", "GE"], ["de", "German", "DE"], ["el", "Greek", "GR"],
  ["ht", "Haitian Creole", "HT"], ["ha", "Hausa", "NG"], ["haw", "Hawaiian", "US"], ["he", "Hebrew", "IL"],
  ["hu", "Hungarian", "HU"], ["is", "Icelandic", "IS"], ["id", "Indonesian", "ID"], ["it", "Italian", "IT"],
  ["ja", "Japanese", "JP"], ["jw", "Javanese", "ID"], ["kk", "Kazakh", "KZ"], ["km", "Khmer", "KH"],
  ["ko", "Korean", "KR"], ["lo", "Lao", "LA"], ["la", "Latin", "VA"], ["lv", "Latvian", "LV"],
  ["ln", "Lingala", "CD"], ["lt", "Lithuanian", "LT"], ["lb", "Luxembourgish", "LU"], ["mk", "Macedonian", "MK"],
  ["mg", "Malagasy", "MG"], ["ms", "Malay", "MY"], ["mt", "Maltese", "MT"], ["mi", "Maori", "NZ"],
  ["mn", "Mongolian", "MN"], ["no", "Norwegian", "NO"], ["nn", "Nynorsk", "NO"], ["oc", "Occitan", "FR"],
  ["ps", "Pashto", "AF"], ["fa", "Persian", "IR"], ["pl", "Polish", "PL"], ["pt", "Portuguese", "BR"],
  ["ro", "Romanian", "RO"], ["ru", "Russian", "RU"], ["sr", "Serbian", "RS"], ["sn", "Shona", "ZW"],
  ["sk", "Slovak", "SK"], ["sl", "Slovenian", "SI"], ["so", "Somali", "SO"], ["es", "Spanish", "ES"],
  ["su", "Sundanese", "ID"], ["sw", "Swahili", "KE"], ["sv", "Swedish", "SE"], ["tl", "Tagalog", "PH"],
  ["tg", "Tajik", "TJ"], ["tt", "Tatar", "RU"], ["th", "Thai", "TH"], ["bo", "Tibetan", "CN"],
  ["tr", "Turkish", "TR"], ["tk", "Turkmen", "TM"], ["uk", "Ukrainian", "UA"], ["uz", "Uzbek", "UZ"],
  ["vi", "Vietnamese", "VN"], ["cy", "Welsh", "GB"], ["yi", "Yiddish", "IL"], ["yo", "Yoruba", "NG"],
];

const flag = (cc) => String.fromCodePoint(...[...cc].map((c) => 0x1f1e6 + c.charCodeAt(0) - 65));

export const LANG_LIST = RAW.map(([id, label, cc]) => ({ id, label, flag: flag(cc) }));
export const MAX_LANGS = 5;
const byId = Object.fromEntries(LANG_LIST.map((l) => [l.id, l]));

export const parseLang = (v) => (!v || v === "auto" ? [] : v.split(",").filter((c) => byId[c]));
export const langLabel = (v) => {
  const codes = parseLang(v);
  if (!codes.length) return "Auto-detect";
  const names = codes.map((c) => byId[c].label);
  return names.length > 2 ? `${names.slice(0, 2).join(" + ")} +${names.length - 2}` : names.join(" + ");
};

// Browser live captions only take one locale; use the first picked language.
export const speechLocale = (v) => {
  const c = parseLang(v)[0];
  if (!c) return navigator.language || "en-IN";
  return c === "hi" ? "hi-IN" : c === "en" || c === "hinglish" ? "en-IN" : c === "jw" ? "jv" : c;
};
